import PropTypes from "prop-types";
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import LodarLight from "../../../components/LodarLight";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  total: PropTypes.number,
  sx: PropTypes.object,
};

export default function AppWidgetSummary({
  title,
  total,
  icon,
  color = "primary",
  sx,
  ...other
}) {
  
const theme = useTheme();
const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));

const StyledIcon = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: "center",
  marginBottom: theme.spacing(isBelow768 ? 2 : 3),
}));
  return (
   
    <Card
      sx={{
        py: isBelow768 ? 2 : 5,
        boxShadow: 2,
        textAlign: "center",
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <StyledIcon
        sx={{
          color: (theme) => theme.palette[color].dark,
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(
              theme.palette[color].dark,
              0
            )} 0%, ${alpha(theme.palette[color].dark, 0.24)} 100%)`,
        }}
      >
        {<Icon icon={icon} width={isBelow768 ? 23 : 28} height={isBelow768 ? 23 : 28} />}
      </StyledIcon>

      <Typography
        variant="h3"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {total === null || total === undefined ? <LodarLight /> : total}
      </Typography>

      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
    </Card>
   
  );
}